export default __webpack_public_path__ + "static/media/BerwickB.363d6987.png";